/* -------------------------------------
 API Config Service
 - Sets urls for correct environment.
-------------------------------------- */

// Angular services
import { Injectable } from '@angular/core';

// Our services & pages
import { AppInstance } from '../shared/enums/app-instance.enum';

export class ApiConfigBase {
    constructor(public readonly apiInstance: AppInstance) { }

    public getInstanceName(): string {
        let value = this.apiInstance;
        return AppInstance[value];
    }
}


//local dev version using ionic serve
@Injectable()
export class ApiConfig extends ApiConfigBase {
    public readonly apiBaseForum:string;
    public readonly authTokenPrefixForum:string;
    public readonly OrganisationGuid: string;
   
    constructor(){
        // super(AppInstance.Dev);
        // this.apiBaseForum = 'http://localhost:51023';
        // this.authTokenPrefixForum = 'BADGE-TOKEN';
        // this.OrganisationGuid = 'efea927346264672839c7990d23bb01c';


        //HAVE YOU CHANGED THE LINK IN badges.html
        // super(AppInstance.Test);
        // this.apiBaseForum = 'http://test.api.enetbadges.ecomscotland.local';
        // this.authTokenPrefixForum = 'BADGE-TOKEN';
        // this.OrganisationGuid = '6a253ba3384242e7887c872542536115';

        super(AppInstance.Live);
        this.apiBaseForum = 'https://api.enetbadges.com/';
        this.authTokenPrefixForum = 'BADGE-TOKEN';
        this.OrganisationGuid = 'b0e32413e4a04f8f87868956b0175de6';

    }
}



// WEBPACK FOOTER //
// ./src/shared/api-config.service.ts